/* esm.sh - esbuild bundle(ccount@2.0.1) deno production */
function r(i,e){let t=String(i);if(typeof e!="string")throw new TypeError("Expected character");let o=0,n=t.indexOf(e);for(;n!==-1;)o++,n=t.indexOf(e,n+e.length);return o}export{r as ccount};
//# sourceMappingURL=ccount.js.map